// Capture Swiper 11 reference before vendor.min.js overrides it with Swiper 4
const SwiperV11 = window.Swiper;

var Shopify = Shopify || {};
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || (window.theme && theme.moneyFormat) || '${{amount}}');
  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number/100.0).toFixed(precision);
    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }
  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};
if (!customElements.get('custom-product-bundle')) {
    customElements.define (
        'custom-product-bundle',
        class CustomProductBundle extends HTMLElement {
            constructor() {
                super();

                this.selectProductsID = [];
                this.charmsProductID = [];
                this.mainImageGroup = this.querySelector('.js-main-product-image');
                this.mainImageCharms = this.querySelectorAll('.js-main-img-charm');
                this.charmsImageGroup = this.querySelector('.js-charms-product-image');

                this.mobBaseTabs = this.querySelectorAll('.js-mob-base-tab');
                this.mobBaseContainers = this.querySelectorAll('.js-mob-tab-container');

                this.isMobile = window.matchMedia('(max-width: 750px)').matches;
                if(this.isMobile) {
                    this.flipFlopSize = this.querySelector('.js-mob-flip-slop-size');
                    this.soleColors = this.querySelectorAll('.js-mob-flip-flop-sole-color');
                    this.activeSole = this.querySelector('.js-mob-flip-flop-sole-color.active-color');
                    this.soleColorName = this.querySelector('.js-mob-sole-color-name');
    
                    this.strapColors = this.querySelectorAll('.js-mob-flip-flop-strap-color');
                    this.activeStrap = this.querySelector('.js-mob-flip-flop-strap-color.active-color');
                    this.strapColorName = this.querySelector('.js-mob-strap-color-name');
                }
                else {
                    this.flipFlopSize = this.querySelector('.js-flip-slop-size');
                    this.soleColors = this.querySelectorAll('.js-flip-flop-sole-color');
                    this.activeSole = this.querySelector('.js-flip-flop-sole-color.active-color');
                    this.soleColorName = this.querySelector('.js-sole-color-name');
    
                    this.strapColors = this.querySelectorAll('.js-flip-flop-strap-color');
                    this.activeStrap = this.querySelector('.js-flip-flop-strap-color.active-color');
                    this.strapColorName = this.querySelector('.js-strap-color-name');
                }

                this.bundleWrapper = this.querySelector('.js-bundle-wrapper');
                this.warningWrapper = this.querySelector('.js-warning-wrapper');

                this.changeFootBtn = this.querySelector('.js-change-foot-btn');
                this.leftFootImage = this.querySelector('.js-charms-left-foot');
                this.rightFootImage = this.querySelector('.js-charms-right-foot');
                this.filters = this.querySelectorAll('.charms-tabs .js-filter');
                
                this.ribbonHardwareFilterBtn = this.querySelector('.js-ribbon-hardware-filter-btn');
                this.ribbonHardwareFilter = this.querySelector('.js-ribbon-hardware-filter');
                this.ribbonSelectedFiltersWrapper = this.querySelector('.js-ribbon-selected-filters');
                this.ribbonFilters = this.querySelectorAll('.ribbons-tabs .js-ribbon-filter');
                
                this.insertPopup = this.querySelector('.js-charms-insert-pop-up');
                this.insertCharm = this.insertPopup.querySelector('.js-charm-insert-btn');
                this.removeCharm = this.insertPopup.querySelector('.js-charm-remove-btn');
                this.rotateCharm = this.insertPopup.querySelector('.js-charm-rotation-btn');

                this.activeCharmPosition = null;
                this.charms = this.querySelectorAll('.js-prod-charms');
                this.charmPositions = this.querySelectorAll('.js-charm-positions');

                let bundleResetBtn = this.querySelector('.js-bundle-reset-btn');
                if(bundleResetBtn) {
                    bundleResetBtn.addEventListener('click', this.resetBundleWarning.bind(this))
                }

                let bundleAddCartBtn = this.querySelector('.js-bundle-add-to-cart');
                if(bundleAddCartBtn) {
                    bundleAddCartBtn.addEventListener('click', this.handleBundleAddToCart.bind(this))
                }
                
                this.activeCharm = null;
                if(this.charmPositions.length > 0) {
                    this.charmPositions.forEach((position) => {
                        position.addEventListener('click', () => {
                            if (this.activeCharm) {
                                let hasCharmClass = Array.from(position.classList).some(cls => cls.startsWith('js-double-spaced-charm'));
                                if (position.classList.contains('js-is-empty') || hasCharmClass) {
                                    this.handleNoPositionPopup();
                                    return;
                                }
                            }

                            this.handleCharms(position);
                            let spaceRequired = position.getAttribute('data-space-required');
                            if(spaceRequired) {
                                this.rotateCharm.classList.toggle('hidden', spaceRequired === "4");
                            }
                        })
                    })
                }
            }
            
            connectedCallback() {
                if(this.isMobile) {
                    this.initializeMobileSoleSlider('js-mob-sole-slider', 1);
                    this.initializeMobileSoleSlider('js-mob-strap-slider', 2);
                }
                else {
                    this.initializeSoleSlider('js-sole-slider', 1);
                    this.initializeSoleSlider('js-strap-slider', 2);
                }
                this.charmsSlider('js-ribbon-grid-slider', 2);
                this.handleTabs();
                this.handleMobBaseTabs();
                this.selectBase();
                this.setFilters();
                this.selectRibbons();
                this.setRibbonFilters();
                if (this.activeSole) this.handleSoleColors(this.activeSole);
                if (this.activeStrap) this.handleStrapColors(this.activeStrap);
                this.handleWarning();
                this.selectFootImage();

                if (this.insertCharm) {
                    this.insertCharm.addEventListener('click', () => {
                    if (this.activeCharmPosition) this.insertSelectedCharm(this.activeCharmPosition);
                    });
                }

                if (this.removeCharm) {
                    this.removeCharm.addEventListener('click', () => {
                    if (this.activeCharmPosition) this.removeSelectedCharm(this.activeCharmPosition);
                    });
                }

                if (this.rotateCharm) {
                    this.rotateCharm.addEventListener('click', () => {
                    if (this.activeCharmPosition) this.rotateSelectedCharm(this.activeCharmPosition);
                    });
                }
            }

            getStrapSizeMapping() {
                return {
                    "32": "2-3",
                    "33": "2-3",
                    "34": "4-5",
                    "35": "4-5",
                    "36": "6-7",
                    "37": "6-7",
                    "38": "8-9",
                    "39": "8-9",
                    "40": "10-11",
                    "41": "10-11",
                    "42": "12-13"
                };
            }

            isElementOutOfStock(el) {
                if (!el) return false;
                if (el.classList.contains('js-clear-charms') || el.classList.contains('js-remove-ribbon')) return false;
                if (el.dataset.outOfStock === 'true' || el.classList.contains('is-out-of-stock')) return true;
                if (el.classList.contains('js-flip-flop-ribbon')) {
                    const qty = parseInt(el.getAttribute('data-inventory-quantity'), 10);
                    if (!isNaN(qty)) return qty <= 1;
                }
                return false;
            }

            updateBaseColorStockStates(type = 'sole') {
                const selectedSize = this.flipFlopSize?.value;
                if (!selectedSize) return;

                const isStrap = type === 'strap';
                const script = this.querySelector(isStrap ? '.js-strap-color-product' : '.js-sole-color-product');
                if (!script) return;

                const data = JSON.parse(script.textContent);
                const swatches = isStrap ? this.strapColors : this.soleColors;
                const sizeMapping = this.getStrapSizeMapping();

                swatches.forEach(swatch => {
                    const colorName = swatch.getAttribute(isStrap ? 'data-strap-color-name' : 'data-sole-color-name');
                    if (!colorName) return;

                    const key = isStrap
                        ? `${sizeMapping[selectedSize]}-${colorName}`
                        : `${selectedSize}-${colorName}`;

                    const variantData = data[key];
                    const inStock = !!(variantData && variantData.available !== false);

                    swatch.classList.toggle('is-out-of-stock', !inStock);
                    swatch.setAttribute('data-out-of-stock', inStock ? 'false' : 'true');
                    swatch.setAttribute('aria-disabled', inStock ? 'false' : 'true');
                    swatch.querySelector('.bundle-stock-label')?.remove();
                });

                const activeSwatch = isStrap ? this.activeStrap : this.activeSole;
                if (activeSwatch?.classList.contains('is-out-of-stock')) {
                    const firstAvailable = Array.from(swatches).find(
                        s => !s.classList.contains('hidden') && !s.classList.contains('is-out-of-stock')
                    );
                    if (firstAvailable) {
                        if (isStrap) this.handleStrapColors(firstAvailable);
                        else this.handleSoleColors(firstAvailable);
                    }
                }
            }

            handleMobBaseTabs() {
                this.mobBaseTabs.forEach((tab) => {
                    tab.addEventListener('click', () => {
                        this.mobBaseTabs.forEach(t => t.classList.remove('active-tab'));
                        tab.classList.add('active-tab');

                        let tabName = tab.getAttribute('data-mob-base-tab');
                        let container = this.querySelector(`.js-mob-tab-container[data-mob-base-container="${tabName}"]`);

                        this.mobBaseContainers.forEach(c => c.classList.add('hidden'));
                        container.classList.remove('hidden');
                    });
                });
            }

            handleTabs() {
                let tabIcons = this.querySelectorAll('.js-tabs-content');
                let tabContents = this.querySelectorAll('.js-tabs-inner');

                if(tabIcons.length > 0 && tabContents.length > 0) {
                    tabIcons.forEach((icon, index) => {
                        icon.addEventListener('click', () => {
                            if (icon.classList.contains('active')) return;
                            let hasSizeSelected = this.flipFlopSize.value;
                            if(hasSizeSelected) {
                                if(!this.warningWrapper.classList.contains('hidden')) this.warningWrapper.classList.add('hidden');
                                if(this.bundleWrapper.classList.contains('hidden')) this.bundleWrapper.classList.remove('hidden');

                                tabIcons.forEach(i => i.classList.remove('active'));
                                tabContents.forEach(c => c.classList.remove('active'));
                
                                icon.classList.add('active');
                                tabContents[index].classList.add('active');

                                if(icon.classList.contains('js-charms-image')) {
                                    this.arrangeCharms();
                                    if(this.charmsImageGroup.classList.contains('hidden')) this.charmsImageGroup.classList.remove('hidden');
                                    if(!this.mainImageGroup.classList.contains('hidden')) this.mainImageGroup.classList.add('hidden');
                                }
                                else {
                                    if(this.mainImageGroup.classList.contains('hidden')) this.mainImageGroup.classList.remove('hidden');
                                    if(!this.charmsImageGroup.classList.contains('hidden')) this.charmsImageGroup.classList.add('hidden');
                                }

                                if(icon.classList.contains('js-add-to-cart-tab')) {
                                    let addCartWarningPopup = this.querySelector('.js-add-to-cart-warning-popup');
                                    if(this.charmsProductID.length == 0) {
                                        addCartWarningPopup.classList.remove('hidden');
                                        this.bundleWrapper.classList.add('hidden');
                                    }
                                    this.handleAddToCartTab(); 
                                }
                            }
                            else {
                                if(this.warningWrapper.classList.contains('hidden')) this.warningWrapper.classList.remove('hidden');
                                if(!this.bundleWrapper.classList.contains('hidden')) this.bundleWrapper.classList.add('hidden');
                            }
                        });
                    });
                }
            }

            handleWarning() {
                let handleWarningBtn = this.querySelector('.js-handle-warning');
                if(handleWarningBtn) {
                    handleWarningBtn.addEventListener('click', () => {
                        if(!this.warningWrapper.classList.contains('hidden')) this.warningWrapper.classList.add('hidden');
                        if(this.bundleWrapper.classList.contains('hidden')) this.bundleWrapper.classList.remove('hidden');
                    })
                }

                let secondStepBtn = this.querySelector('.js-go-second-step-btn');
                if(secondStepBtn) {
                    secondStepBtn.addEventListener('click', () => {
                        this.querySelector('.js-no-space-popup')?.classList.add('hidden');
                        this.bundleWrapper?.classList.remove('hidden');
                    })
                }

                let cartOkBtn = this.querySelector('.js-cart-ok-gtn');
                if(cartOkBtn) {
                    cartOkBtn.addEventListener('click', () => {
                        this.querySelector('.js-add-to-cart-warning-popup')?.classList.add('hidden');
                        this.bundleWrapper?.classList.remove('hidden');
                    })
                }
                
                let cartGoBackBtn = this.querySelector('.js-cart-go-back');
                if(cartGoBackBtn) {
                    cartGoBackBtn.addEventListener('click', () => {
                        let tabIcons = this.querySelectorAll('.js-tabs-content');
                        tabIcons[1].click();

                        this.querySelector('.js-add-to-cart-warning-popup')?.classList.add('hidden');
                        this.bundleWrapper?.classList.remove('hidden');
                    })
                }

                let handleResetBtns = this.querySelectorAll('.js-rest-btn');
                if(handleResetBtns.length > 0) {
                    handleResetBtns.forEach((btn) => {
                        btn.addEventListener('click', () => {
                            this.querySelector('.js-reset-warning-popup')?.classList.add('hidden');
                            this.bundleWrapper?.classList.remove('hidden');
                            if(btn.classList.contains('js-yes-btn')) {
                                this.resetBundle();
                            }
                        })
                    }) 
                }
            }
            
            selectBase() {
                if (this.flipFlopSize) {
                    this.flipFlopSize.addEventListener('change', () => {
                        this.handleStrapSize();
                        this.handleSoleSize();
                    });
                }

                if (this.soleColors.length > 0) {
                    this.soleColors.forEach((sole) => {
                        sole.addEventListener('click', () => {
                            this.handleSoleColors(sole);
                        });
                    });
                }

                if (this.strapColors.length > 0) {
                    this.strapColors.forEach((strap) => {
                        strap.addEventListener('click', () => {
                            this.handleStrapColors(strap);
                        });
                    });
                }
            }

            handleSoleSize() {
                let selectedSize = this.flipFlopSize.value;
                let soleColorScript = this.querySelector('.js-sole-color-product');
                if (!soleColorScript || !selectedSize) return;

                let soleData = JSON.parse(soleColorScript.textContent);
                let visibilityChanged = false;

                this.soleColors.forEach(sole => {
                    let colorName = sole.getAttribute('data-sole-color-name');
                    let key = `${selectedSize}-${colorName}`;
                    let shouldShow = soleData.hasOwnProperty(key);
                    let isHidden = sole.classList.contains('hidden');

                    if (shouldShow && isHidden) {
                        sole.classList.remove('hidden');
                        visibilityChanged = true;
                    } else if (!shouldShow && !isHidden) {
                        sole.classList.add('hidden');
                        visibilityChanged = true;
                    }
                });

                if (visibilityChanged) {
                    setTimeout(() => {
                        if(this.isMobile) {
                            this.initializeMobileSoleSlider('js-mob-sole-slider', 1);
                        }
                        else {
                            this.initializeSoleSlider('js-sole-slider', 1);
                        }
                    }, 50);
                }

                if (!this.activeSole) return;

                let handleizedSoleName = this.activeSole.getAttribute("data-sole-color-name");
                let scriptKey = `${selectedSize}-${handleizedSoleName}`;

                let soleImageScript = this.querySelector('.js-sole-color-product');
                let imageData = JSON.parse(soleImageScript.textContent);
                
                let variantData = imageData[scriptKey];
                if(variantData && variantData.variant_id) {
                    this.selectProductsID = this.selectProductsID.filter(item => !('soleColor' in item || 'soleColorPrice' in item));
                    this.selectProductsID.push(
                        { soleColor: variantData.variant_id },
                        { soleColorPrice: variantData.variant_price }
                    );
                }

                this.updateBaseColorStockStates('sole');
                this.handleTotalPrice();
            }

            handleStrapSize() {
                let selectedSize = this.flipFlopSize.value;
                let strapColorScript = this.querySelector('.js-strap-color-product');
                if (!strapColorScript || !selectedSize) return;

                let strapData = JSON.parse(strapColorScript.textContent);
                let visibilityChanged = false;

                let sizeStrapMapping = this.getStrapSizeMapping();

                this.strapColors.forEach(strap => {
                    let colorName = strap.getAttribute('data-strap-color-name');
                    let key = `${sizeStrapMapping[selectedSize]}-${colorName}`;
                    let shouldShow = strapData.hasOwnProperty(key);
                    let isHidden = strap.classList.contains('hidden');

                    if (shouldShow && isHidden) {
                        strap.classList.remove('hidden');
                        visibilityChanged = true;
                    } else if (!shouldShow && !isHidden) {
                        strap.classList.add('hidden');
                        visibilityChanged = true;
                    }
                });

                if (visibilityChanged) {
                    setTimeout(() => {
                        if(this.isMobile) {
                            this.initializeMobileSoleSlider('js-mob-strap-slider', 2);
                        }
                        else {
                            this.initializeSoleSlider('js-strap-slider', 2);
                        }
                    }, 50);
                }

                if (!this.activeStrap) return;

                let handleizedStrapName = this.activeStrap.getAttribute("data-strap-color-name");
                let scriptKey = `${sizeStrapMapping[selectedSize]}-${handleizedStrapName}`;

                let strapImageScript = this.querySelector('.js-strap-color-product');
                let strapImageData = JSON.parse(strapImageScript.textContent);
                
                let variantData = strapImageData[scriptKey];
                if(variantData && variantData.variant_id) {
                    this.selectProductsID = this.selectProductsID.filter(item => !('strapColor' in item || 'strapColorPrice' in item || 'strapSize' in item));
                    this.selectProductsID.push(
                        { strapColor: variantData.variant_id },
                        { strapColorPrice: variantData.variant_price },
                        { strapSize: sizeStrapMapping[selectedSize] }
                    );
                }

                this.updateBaseColorStockStates('strap');
                this.handleTotalPrice();
            }

            handleSoleColors(sole) {
                if (!sole || this.isElementOutOfStock(sole)) return;

                this.soleColors.forEach(s => s.classList.remove('active-color'));
                sole.classList.add('active-color');

                let handlizedSoleColor = sole.getAttribute('data-sole-color-name');
                let soleColor = sole.getAttribute('data-color-name');
                this.soleColorName.innerHTML = soleColor;

                this.activeSole = sole;

                let soleImageScript = this.querySelector('.js-sole-color-product');
                let imageData = JSON.parse(soleImageScript.textContent);

                let leftSole = this.querySelector('.js-left-sole');
                let rightSole = this.querySelector('.js-right-sole');
                let leftFootSole = this.querySelector('.js-charms-left-foot-sole');
                let rightFootSole = this.querySelector('.js-charms-right-foot-sole');

                let sizeValue = this.flipFlopSize.value || "";
                let variantName = `${sizeValue}-${handlizedSoleColor}`;

                let variantData = imageData[variantName];

                if (!variantData) {
                    for (let key in imageData) {
                        if (key.includes(handlizedSoleColor)) {
                            variantData = imageData[key];
                            break;
                        }
                    }
                }

                if (variantData && variantData.left_sole_side && variantData.right_sole_side) {
                    leftSole.src = variantData.left_sole_side;
                    leftFootSole.src = variantData.left_sole_side;
                    rightSole.src = variantData.right_sole_side;
                    rightFootSole.src = variantData.right_sole_side;
                }

                if(variantData && variantData.variant_id) {
                    this.selectProductsID = this.selectProductsID.filter(item => !('soleColor' in item || 'soleColorPrice' in item));
                    this.selectProductsID.push(
                        { soleColor: variantData.variant_id },
                        { soleColorPrice: variantData.variant_price }
                    );
                }

                this.handleTotalPrice();
            }

            handleStrapColors(strap) {
                if (!strap || this.isElementOutOfStock(strap)) return;

                this.strapColors.forEach(s => s.classList.remove('active-color'));
                strap.classList.add('active-color');

                let handlizedStrapColor = strap.getAttribute('data-strap-color-name');
                let strapColor = strap.getAttribute('data-color-name');
                this.strapColorName.innerHTML = strapColor;

                this.activeStrap = strap;
                
                let strapImageScript = this.querySelector('.js-strap-color-product');
                let strapImageData = JSON.parse(strapImageScript.textContent);

                let leftStrap = this.querySelector('.js-left-strap');
                let rightStrap = this.querySelector('.js-right-strap');
                let leftFootStrap = this.querySelector('.js-charms-left-foot-strap');
                let rightFootStrap = this.querySelector('.js-charms-right-foot-strap');

                let sizeValue = this.flipFlopSize.value || "";

                let sizeStrapMapping = {
                    "32": "2-3",
                    "33": "2-3",
                    "34": "4-5",
                    "35": "4-5",
                    "36": "6-7",
                    "37": "6-7",
                    "38": "8-9",
                    "39": "8-9",
                    "40": "10-11",
                    "41": "10-11",
                    "42": "12-13"
                };

                let variantName = `${sizeStrapMapping[sizeValue]}-${handlizedStrapColor}`;

                let variantData = strapImageData[variantName];

                if (!variantData) {
                    for (let key in strapImageData) {
                        if (key == `2-3-${handlizedStrapColor}`) {
                            variantData = strapImageData[key];
                            break;
                        }
                    }
                }

                if (variantData && variantData.left_strap_side && variantData.right_strap_side) {
                    leftStrap.src = variantData.left_strap_side;
                    leftFootStrap.src = variantData.left_strap_side;
                    rightStrap.src = variantData.right_strap_side;
                    rightFootStrap.src = variantData.right_strap_side;
                }

                if(variantData && variantData.variant_id) {
                    this.selectProductsID = this.selectProductsID.filter(item => !('strapColor' in item || 'strapColorPrice' in item || 'strapSize' in item));
                    this.selectProductsID.push(
                        { strapColor: variantData.variant_id },
                        { strapColorPrice: variantData.variant_price },
                        { strapSize: sizeStrapMapping[sizeValue] }
                    );
                }

                this.handleTotalPrice();
            }

            arrangeCharms() {
                let charmsContainer = this.querySelector(".js-charms-container");
                let charmsDataScript = this.querySelector(".js-charms-data");

                if (!charmsContainer || !charmsDataScript) return;

                let charmsData = JSON.parse(charmsDataScript.textContent);
                charmsContainer.innerHTML = "";

                Object.entries(charmsData).forEach(([key, charmHTML]) => {
                    let tempWrapper = document.createElement("div");
                    tempWrapper.innerHTML = charmHTML;
                    let slide = tempWrapper.firstElementChild;
                    if (slide && !slide.classList.contains('hidden')) {
                        charmsContainer.appendChild(slide);
                    }
                });
                this.charmsSlider('js-charm-grid-slider', 1);
                this.bindEventListeners();
                this.applyStockStateToSlides(this.prodCharms);
            }

            applyStockStateToSlides(slides) {
                if (!slides || !slides.length) return;
                slides.forEach(slide => {
                    if (this.isElementOutOfStock(slide)) {
                        slide.classList.add('is-out-of-stock');
                        slide.setAttribute('aria-disabled', 'true');
                    }
                });
            }

            bindEventListeners() {
                this.prodCharms = this.querySelectorAll('.js-flip-flop-charm');
                this.clearCharmsBtn = this.querySelector('.js-clear-charms');

                if (this.clearCharmsBtn && !this.clearCharmsBtn.dataset.bound) {
                    this.clearCharmsBtn.addEventListener('click', () => {
                        this.clearCharms();
                    });
                    this.clearCharmsBtn.dataset.bound = "true";
                }

                this.prodCharms.forEach((charm) => {
                    if (!charm.dataset.bound) {
                        charm.addEventListener('click', () => {
                            if (this.isElementOutOfStock(charm)) return;
                            this.prodCharms.forEach(c => c.classList.remove('active'));
                            charm.classList.add('active');
                            this.activeCharm = charm;
                            this.placeCharms(charm);
                        });
                        charm.addEventListener('mouseenter', () => {
                            if (this.isElementOutOfStock(charm)) return;
                            this.charmImageZoom(charm);
                        })
                        charm.dataset.bound = "true";
                    }
                });
            }

            charmImageZoom(charm) {
                let imageZoomWrapper = this.querySelector('.js-charm-img-zoom');
                let tabWrapper = this.querySelector('.js-tab-wrapper');
                if(!charm || !imageZoomWrapper || !tabWrapper) return;

                imageZoomWrapper.classList.remove("hidden");
                let zoomInnerImage = imageZoomWrapper.querySelector('.js-inner-zoom-img');
                let charmImageWrapper = charm.querySelector('img');
                let charmImageSrc = charmImageWrapper.getAttribute('src')

                let charmRect = charm.getBoundingClientRect();
                let containerRect = tabWrapper.getBoundingClientRect();

                let top = charmRect.top - containerRect.top;
                let left = charmRect.left - containerRect.left;

                zoomInnerImage.style.backgroundImage = `url("${charmImageSrc}")`;
                imageZoomWrapper.style.top = `${top}px`;
                imageZoomWrapper.style.left = `${left}px`;
            }

            setFilters() {
                let themeFilterBtn = this.querySelector('.js-theme-filter-btn');
                let themeFilter = this.querySelector('.js-theme-filter-charm');
                let colorFilterBtn = this.querySelector('.js-color-filter-btn');
                let colorFilter = this.querySelector('.js-color-filter-charm');
                let selectedFiltersWrapper = this.querySelector('.js-selected-filters');
                
                let charmsContainer = this.querySelector(".js-charms-container");
                if (charmsContainer) {
                    charmsContainer.addEventListener('mouseleave', () => {
                        this.querySelector('.js-charm-img-zoom')?.classList.add("hidden")
                    })
                }

                if (themeFilterBtn && themeFilter) {
                    themeFilterBtn.addEventListener('click', () => {
                        themeFilter.classList.toggle('hidden');
                        themeFilterBtn.classList.toggle('active');
                        if(colorFilter && !colorFilter.classList.contains('hidden')) colorFilter.classList.add('hidden');
                        if(colorFilterBtn && colorFilterBtn.classList.contains('active')) colorFilterBtn.classList.remove('active');
                    });
                }

                if (colorFilterBtn && colorFilter) {
                    colorFilterBtn.addEventListener('click', () => {
                        colorFilter.classList.toggle('hidden');
                        colorFilterBtn.classList.toggle('active');
                        if(themeFilter && !themeFilter.classList.contains('hidden')) themeFilter.classList.add('hidden');
                        if(themeFilterBtn && themeFilterBtn.classList.contains('active')) themeFilterBtn.classList.remove('active');
                    });
                }

                if(this.filters.length > 0) {
                    this.filters.forEach((filter) => {
                        filter.addEventListener('click', () => {
                            filter.classList.add('active', 'hidden');
                            this.applyFilters();

                            let dataFilter = filter.getAttribute('data-filter');
                            
                            let selectedButton = document.createElement('button');
                            selectedButton.classList.add('js-selected-filter');
                            selectedButton.setAttribute('data-filter', dataFilter);
                            selectedButton.innerHTML = `${filter.innerHTML} <span class="remove-filter">X</span>`;
                            selectedFiltersWrapper.appendChild(selectedButton);

                            if(selectedFiltersWrapper.classList.contains('hidden')) selectedFiltersWrapper.classList.remove('hidden');
                            if(themeFilter) themeFilter.classList.add('hidden');
                            if(themeFilterBtn) themeFilterBtn.classList.remove('active');
                            if(colorFilter) colorFilter.classList.add('hidden');
                            if(colorFilterBtn) colorFilterBtn.classList.remove('active');

                            selectedButton.addEventListener('click', () => {
                                selectedButton.remove();
                                let originalFilter = this.querySelector(`.charms-tabs .js-filter[data-filter="${dataFilter}"]`);
                                if (originalFilter) {
                                    originalFilter.classList.remove('active', 'hidden');
                                }
                                this.applyFilters();

                                if (selectedFiltersWrapper.children.length === 0) {
                                    selectedFiltersWrapper.classList.add('hidden');
                                }
                            });
                        });
                    });
                }
            }

            setRibbonFilters() {
                // Guard – hardware‑filter UI must exist
                if (!this.ribbonHardwareFilterBtn || !this.ribbonHardwareFilter) return;

                // Toggle hardware‑filter drawer
                this.ribbonHardwareFilterBtn.addEventListener('click', () => {
                    this.ribbonHardwareFilter.classList.toggle('hidden');
                    this.ribbonHardwareFilterBtn.classList.toggle('active');
                });

                // Initialise any pre‑selected UI state
                this._resetAllRibbonSlides();

                // Attach click handlers to each filter button
                if (this.ribbonFilters.length) {
                    this.ribbonFilters.forEach(filter => {
                        filter.addEventListener('click', () => {
                            // Visually hide the filter and mark it active
                            filter.classList.add('active', 'hidden');

                            // Refresh the ribbon grid
                            this.applyRibbonFilters();

                            // Create “selected” filter chip
                            const dataFilter = filter.getAttribute('data-filter');
                            const selectedBtn = document.createElement('button');
                            selectedBtn.classList.add('js-ribbon-selected-filter');
                            selectedBtn.setAttribute('data-filter', dataFilter);
                            selectedBtn.innerHTML = `${filter.innerHTML} <span class="remove-filter">X</span>`;

                            // Append to the wrapper and ensure wrapper is visible
                            if (this.ribbonSelectedFiltersWrapper) {
                                this.ribbonSelectedFiltersWrapper.appendChild(selectedBtn);
                                this.ribbonSelectedFiltersWrapper.classList.remove('hidden');
                            }

                            // Close hardware drawer
                            this.ribbonHardwareFilter.classList.add('hidden');
                            this.ribbonHardwareFilterBtn.classList.remove('active');

                            // Removal handler – restores original filter button
                            selectedBtn.addEventListener('click', () => {
                                selectedBtn.remove();
                                const original = this.querySelector(`.ribbons-tabs .js-ribbon-filter[data-filter="${dataFilter}"]`);
                                if (original) original.classList.remove('active', 'hidden');
                                this.applyRibbonFilters();

                                // Hide wrapper when empty
                                if (this.ribbonSelectedFiltersWrapper && !this.ribbonSelectedFiltersWrapper.children.length) {
                                    this.ribbonSelectedFiltersWrapper.classList.add('hidden');
                                }
                            });
                        });
                    });
                }
            }

            /** Reset all ribbon slides to visible – called on init & on clear */
            _resetAllRibbonSlides() {
                const slides = this.querySelectorAll('.ribbons-tabs .js-flip-flop-ribbon');
                slides.forEach(slide => {
                    slide.classList.remove('hidden');
                    slide.classList.add('swiper-slide');
                });
                if (this.gridSlider_2) {
                    this.gridSlider_2.update();
                    this.gridSlider_2.slideTo(0);
                }
            }

            applyRibbonFilters() {
                const activeFilters = Array.from(this.ribbonFilters)
                    .filter(btn => btn.classList.contains('active'))
                    .map(btn => btn.getAttribute('data-filter').toLowerCase());

                // Query by the custom ribbon class, NOT .swiper-slide, since we remove that class to hide items.
                const slides = this.querySelectorAll('.ribbons-tabs .js-flip-flop-ribbon:not(.js-remove-ribbon)');

                slides.forEach(slide => {
                    const labels = (slide.getAttribute('data-filter-labels') || '')
                        .split(',')
                        .map(l => l.trim().toLowerCase());

                    const shouldShow = !activeFilters.length ||
                        activeFilters.some(f => labels.includes(f));

                    if (shouldShow) {
                        slide.classList.remove('hidden');
                        slide.classList.add('swiper-slide');
                    } else {
                        slide.classList.add('hidden');
                        slide.classList.remove('swiper-slide');
                    }
                });

                // Refresh the Swiper instance for ribbons
                if (this.gridSlider_2) {
                    this.gridSlider_2.update();
                    this.gridSlider_2.slideTo(0);
                }
            }


            placeCharms(charm) {
                if (this.isElementOutOfStock(charm)) return;

                let selectedFootImg = this.querySelector('.js-charm-image:not(.hidden)');
                let selectedfootSide = selectedFootImg.getAttribute('data-foot-side');
                if(!this.insertPopup.classList.contains('hidden')) this.insertPopup.classList.add('hidden');

                let charmName = this.querySelector('.js-charm-name');
                let charmId = charm.getAttribute("data-charm-variant-id");
                let charmPrice = charm.getAttribute('data-charm-variant-price');
                let variantName = charm.getAttribute('data-charm-variant-title');
                charmName.innerHTML = variantName;

                if(charm.classList.contains('js-clear-charms')) return;

                let containers = [
                    selectedFootImg.querySelector('.js-charm-c1'),
                    selectedFootImg.querySelector('.js-charm-c2'),
                    selectedFootImg.querySelector('.js-charm-c3'),
                    selectedFootImg.querySelector('.js-charm-c4'),
                    selectedFootImg.querySelector('.js-charm-c5'),
                    selectedFootImg.querySelector('.js-charm-c6'),
                    selectedFootImg.querySelector('.js-charm-c7')
                ];

                containers.forEach(container => {
                    if (!container.classList.contains('js-charms-added')) {
                        container.src = "";
                        container.style.opacity = '0.3';
                        container.style.cursor = 'default';
                        if(container.classList.contains('charm-bigger-image')) container.classList.remove('charm-bigger-image');
                    }
                });
                this.charmPositions.forEach((position) => {
                    if(!position.classList.contains('js-is-not-empty')) {
                        position.classList.add('js-is-empty');
                        position.removeAttribute('data-space-required');
                    } 
                });

                let charmReqPositon = charm.getAttribute('data-position-required');
                if(charmReqPositon == "4") {
                    this.rotateCharm?.classList.add('hidden');
                    this.handleBiggerCharms(charm, containers, selectedFootImg, variantName, charmId, charmPrice);
                    return;
                }
                this?.rotateCharm?.classList.remove('hidden');

                let charmImage = charm.querySelector('img');
                if (!charmImage) return;
                let imageSrc = charmImage.getAttribute('src');
                
                if (charmReqPositon == "2") {
                    let isLeft = selectedfootSide === "left";
                    let baseIndex = isLeft ? 0 : 7;
                    let pos1 = baseIndex + 1;
                    let pos5 = baseIndex + 5;
                    let dynamicMapping = {
                        [pos1]: [0, 2],
                        [pos5]: [4, 6]
                    };
                    
                    let posA = isLeft ? 1 : 8;
                    let posB = isLeft ? 5 : 12;
                    
                    let positionsToCheck = isLeft ? [0, 1, 2, 4, 5, 6] : [7, 8, 9, 11, 12, 13];
                    let allFilled = positionsToCheck.every(index =>
                        this.charmPositions[index]?.classList.contains('js-is-not-empty')
                    );

                    let isBlocked = (index) => {
                        let pos = this.charmPositions[index];
                        if (!pos) return false;

                        let hasNotEmpty = pos.classList.contains('js-is-not-empty');
                        let doubleSpacedClasses = Array.from(pos.classList).filter(cls =>
                            cls.startsWith('js-double-spaced-charm')
                        );

                        return (
                            hasNotEmpty &&
                            (doubleSpacedClasses.length === 0 || doubleSpacedClasses.length === 2)
                        );
                    };

                    let isOnePlaceFilled = (index) => {
                        let pos = this.charmPositions[index];
                        if (!pos) return false;

                        let minusOneIndex = this.charmPositions[index - 1].classList.contains('js-is-not-empty');
                        let PlusOneIndex = this.charmPositions[index + 1].classList.contains('js-is-not-empty');
                        let doubleSpacedClasses = Array.from(pos.classList).filter(cls =>
                            cls.startsWith('js-double-spaced-charm')
                        );

                        return (minusOneIndex && PlusOneIndex && (doubleSpacedClasses.length === 0 || doubleSpacedClasses.length === 1));
                    }
                    
                    if ((isBlocked(posA) && isBlocked(posB)) || allFilled || (isOnePlaceFilled(posA) && isOnePlaceFilled(posB)) || 
                        (isBlocked(posA) && isOnePlaceFilled(posB)) || (isBlocked(posB) && isOnePlaceFilled(posA))
                    ) {
                        this.handleNoPositionPopup();
                        return;
                    }

                    for (let pos in dynamicMapping) {
                        pos = parseInt(pos);
                        let hasCharmClass = Array.from(this.charmPositions[pos]?.classList).some(cls => cls.startsWith('js-double-spaced-charm'));
                        if (!this.charmPositions[pos]?.classList.contains('js-is-not-empty') || hasCharmClass) {
                            dynamicMapping[pos].forEach(index => {
                                let container = containers[index];
                                if (container && !container.classList.contains('js-charms-added')) {
                                    container.src = imageSrc;
                                    container.style.opacity = '0.3';
                                    container.style.cursor = 'pointer';
                                    container.setAttribute("data-charm-name", variantName);
                                    container.setAttribute("data-charm-id", charmId);
                                    container.setAttribute("data-charm-price", charmPrice);

                                    let charmPos = this.charmPositions[index + baseIndex];
                                    if (charmPos?.classList.contains('js-is-empty')) {
                                        charmPos.classList.remove('js-is-empty');
                                        charmPos.setAttribute('data-space-required', charmReqPositon);
                                    }
                                }
                            });
                        }
                    }
                }
                else {
                    let isLeft = selectedfootSide === "left";
                    let isSide3Blocked = (sideIndex) => {
                        let base = isLeft ? 0 : 7;
                        let offset = sideIndex === 0 ? 0 : 4;
                        let indicesToCheck = [base + offset, base + offset + 1, base + offset + 2];
                        return indicesToCheck.some(idx => this.charmPositions[idx]?.classList.contains('js-is-not-empty'));
                    };

                    if (charmReqPositon == "3" && isSide3Blocked(0) && isSide3Blocked(4)) {
                        this.handleNoPositionPopup();
                        return;
                    }

                    containers.forEach((container, index) => {
                        if(charmReqPositon == "3") {
                            if(index != 0 && index != 4) return;
                            if(isSide3Blocked(index)) return;
                        }
                        if (!container.classList.contains('js-charms-added')) {
                            container.src = imageSrc;
                            container.style.opacity = '0.3';
                            container.style.cursor = 'pointer';
                            container.setAttribute("data-charm-name", variantName);
                            container.setAttribute("data-charm-id", charmId);
                            container.setAttribute("data-charm-price", charmPrice);
                        }
                    });

                    this.charmPositions.forEach((position, index) => {
                        position.classList.remove('js-forbidden-slot');
                        let isLeft = selectedfootSide === "left";
                        let side1Indices = isLeft ? [0, 1, 2] : [7, 8, 9];
                        let side2Indices = isLeft ? [4, 5, 6] : [11, 12, 13];

                        if(charmReqPositon == "3") {
                            let isSide1Allowed = !isSide3Blocked(0);
                            let isSide2Allowed = !isSide3Blocked(4);

                            if(side1Indices.includes(index) && isSide1Allowed) {
                                position.classList.remove('js-is-empty');
                                position.setAttribute('data-space-required', charmReqPositon);
                            } else if(side2Indices.includes(index) && isSide2Allowed) {
                                position.classList.remove('js-is-empty');
                                position.setAttribute('data-space-required', charmReqPositon);
                            }
                            return;
                        }


                        if(position.classList.contains('js-is-empty')) {
                            position.classList.remove('js-is-empty');
                            position.setAttribute('data-space-required', charmReqPositon);
                        } 
                    });
                }
            }

            handleBiggerCharms(charm, containers, selectedFootImg, variantName, charmId, charmPrice) {
                let footSide = selectedFootImg.getAttribute('data-foot-side');
                let isLeft = footSide === "left";
                let imageSrc = charm.getAttribute(isLeft ? 'data-left-src' : 'data-right-src');
                let startIndex = isLeft ? 0 : 10;
                let endIndex = isLeft ? 4 : 14;
                let charmIndex = isLeft ? 0 : 4;
                let charmSlice = Array.from(this.charmPositions).slice(startIndex, endIndex);
                let allEmpty = charmSlice.every(pos => pos.classList.contains('js-is-empty'));
                
                if (allEmpty) {
                    let container = Array.from(containers)[charmIndex];
                    container.src = imageSrc;
                    container.style.opacity = '0.3';
                    container.style.cursor = 'pointer';
                    container.classList.add('charm-bigger-image');
                    container.setAttribute("data-charm-name", variantName);
                    container.setAttribute("data-charm-id", charmId);
                    container.setAttribute("data-charm-price", charmPrice);

                    charmSlice.forEach(pos => {
                        pos.classList.remove('js-is-empty');
                        pos.setAttribute('data-space-required', "4");
                    });
                } else {
                    this.handleNoPositionPopup();
                }
            }

            handleNoPositionPopup() {
                let noCharmSpacePopup = this.querySelector(".js-no-space-popup");
                if (noCharmSpacePopup && this.bundleWrapper) {
                    this.bundleWrapper.classList.add("hidden");
                    noCharmSpacePopup.classList.remove('hidden');
                }
            }

            clearCharms() {
                let charmName = this.querySelector('.js-charm-name');
                charmName.innerHTML = "None";
                this.charmPositions.forEach((position) => {
                    position.classList.add('js-is-empty');
                    if(position.classList.contains('js-is-not-empty')) {
                        position.classList.remove('js-is-not-empty');
                        position.removeAttribute('data-space-required');

                        Array.from(position.classList).forEach(cls => {
                            if (cls.startsWith('js-double-spaced-charm')) {
                                position.classList.remove(cls);
                            }
                        });
                    }
                });
                this.charms.forEach((charm) => {
                    charm.classList.remove('js-charms-added', 'charm-bigger-image');
                    charm.src = "";
                    charm.removeAttribute('data-rotation');
                    charm.removeAttribute('data-charm-name');
                    charm.removeAttribute('data-charm-id');
                    charm.removeAttribute('data-charm-price');
                    charm.removeAttribute('style');
                    charm.style.opacity = '0.3';
                    charm.style.cursor = 'default';
                });
                this.mainImageCharms.forEach((charmImg) => {
                    charmImg.src = "";
                    charmImg.classList.remove('charm-bigger-image');
                    charmImg.removeAttribute('data-rotation');
                    charmImg.removeAttribute('style');
                })
                this.charmsProductID = [];

                this.prodCharms.forEach(c => c.classList.remove('active'));
                this.clearCharmsBtn.classList.add('active');

                this.handleTotalPrice();
            }

            handleCharms(position) {
                let hasCharmClass = Array.from(position.classList).some(cls => cls.startsWith('js-double-spaced-charm'));
                if(position.classList.contains('js-is-empty') || hasCharmClass) return;
                if(this.insertPopup.classList.contains('hidden')) this.insertPopup.classList.remove('hidden');
                this.activeCharmPosition = position;
            }

            insertSelectedCharm(position) {
                let footSide = position.getAttribute('data-foot-side');
                let charmPosition = position.getAttribute('data-position');
                let allCharmPosition = Array.from(this.charms).filter(charm => charm.getAttribute('data-foot-side') === footSide);

                let charmReq = this.activeCharm ? this.activeCharm.getAttribute('data-position-required') : null;
                
                // Logic 3 Redirect
                if (charmReq == "3") {
                    let index = parseInt(position.getAttribute('data-position-index'));
                    let redirectMap = {
                        "2": "1", "3": "1",
                        "6": "5", "7": "5",
                        "9": "8", "10": "8",
                        "13": "12", "14": "12"
                    };
                    let primaryIndex = redirectMap[index];
                    if (primaryIndex) {
                        position = this.querySelector(`.js-charm-positions[data-position-index="${primaryIndex}"]`);
                    }
                }


                if(!this.insertPopup.classList.contains('hidden')) this.insertPopup.classList.add('hidden');

                let charm = this.querySelector(`.js-prod-charms[data-position="${charmPosition}"]`);

                let charmPositionReq = position.getAttribute('data-space-required');
                if(charmPositionReq == "4") {
                    if(charm.classList.contains('js-charms-added')) return;
                    this.insertBiggerCharm(position);
                    return;
                }

                let charmImagePosition = charm.getAttribute("data-charm-prop");
                let CharmVariantName = charm.getAttribute("data-charm-name");
                let charmVariantId = charm.getAttribute("data-charm-id");
                let charmVariantPrice = charm.getAttribute("data-charm-price");
                let charmRotation = parseInt(charm.getAttribute("data-rotation")) || 0;

                this.charmsProductID = this.charmsProductID.filter(entry => {
                    let [pos, name, id, price] = entry.split(":");
                    return !(
                        pos === charmImagePosition &&
                        name === CharmVariantName &&
                        id === charmVariantId &&
                        price === charmVariantPrice
                    );
                });

                this.charmsProductID.push(`${charmImagePosition}:${CharmVariantName}:${charmVariantId}:${charmVariantPrice}:${charmRotation}`);

                if(charm.classList.contains('js-charms-added')) return;

                allCharmPosition.forEach(container => {
                    if (container !== charm && !container.classList.contains('js-charms-added')) {
                        container.src = '';
                        container.style.opacity = '0.3';
                        container.style.cursor = 'default';
                        container.removeAttribute("data-charm-id");
                        container.removeAttribute("data-charm-price");
                        container.removeAttribute("data-charm-name");
                    }
                });

                charm.style.opacity = '1';
                charm.style.cursor = 'pointer';
                charm.classList.add('js-charms-added');
                position.classList.add('js-is-not-empty');

                let imageSrc = charm.getAttribute('src');

                let charmProp = charm.getAttribute('data-charm-prop');
                if (charmProp) {
                    let mainImageElement = this.mainImageGroup.querySelector(`[data-charm-prop="${charmProp}"]`);
                    if (mainImageElement) {
                        mainImageElement.src = imageSrc;
                    }
                }

                if (charmPositionReq == "2") {
                    let pairMap = {
                        "1": "2",
                        "3": "2",
                        "5": "6",
                        "7": "6",
                        "8": "9",
                        "10": "9",
                        "12": "13",
                        "14": "13"
                    };
                    let placePosition = position.getAttribute('data-position-index');
                    let mappedIndex = pairMap[placePosition];
                    if (mappedIndex) {
                        let positionToFilled = this.querySelector(`.js-charm-positions[data-position-index="${mappedIndex}"]`);
                        let charmToFilled = this.querySelector(`.js-prod-charms[data-position-index="${mappedIndex}"]`);
                        if (charmToFilled && positionToFilled) {
                            charmToFilled.classList.add('js-charms-added');
                            positionToFilled.classList.remove('js-is-empty');
                            positionToFilled.classList.add('js-is-not-empty');
                            positionToFilled.classList.add(`js-double-spaced-charm-${placePosition}`);
                        }
                    }
                }

                if (charmPositionReq == "3") {
                    let tripleMap = {
                        "1": ["2", "3"],
                        "5": ["6", "7"],
                        "8": ["9", "10"],
                        "12": ["13", "14"]
                    };
                    let placePosition = position.getAttribute('data-position-index');
                    let mappedIndices = tripleMap[placePosition];
                    if (mappedIndices) {
                        mappedIndices.forEach(mappedIndex => {
                            let positionToFilled = this.querySelector(`.js-charm-positions[data-position-index="${mappedIndex}"]`);
                            let charmToFilled = this.querySelector(`.js-prod-charms[data-position-index="${mappedIndex}"]`);
                            if (charmToFilled && positionToFilled) {
                                charmToFilled.classList.add('js-charms-added');
                                positionToFilled.classList.remove('js-is-empty');
                                positionToFilled.classList.add('js-is-not-empty');
                                positionToFilled.classList.add(`js-triple-spaced-charm-${placePosition}`);
                            }
                        });
                    }
                }

                this.charmPositions.forEach((position) => {
                    if(!position.classList.contains('js-is-not-empty')) {
                        position.classList.add('js-is-empty');
                        position.removeAttribute('data-space-required');
                    }
                })

                this.handleTotalPrice();
            }

            insertBiggerCharm(position) {
                let isLeft = position.getAttribute('data-foot-side') === "left";
                let charmSelector = isLeft ? '[data-position="left-c1"]' : '[data-position="right-c5"]';
                let start = isLeft ? 0 : 10;
                let end = start + 4;

                let charm = this.querySelector(`.js-prod-charms${charmSelector}`);
                if (charm) {
                    let charmImagePosition = charm.getAttribute("data-charm-prop");
                    let CharmVariantName = charm.getAttribute("data-charm-name");
                    let charmVariantId = charm.getAttribute("data-charm-id");
                    let charmVariantPrice = charm.getAttribute("data-charm-price");
                    let charmRotation = 0;

                    charm.style.opacity = '1';
                    charm.style.cursor = 'pointer';
                    charm.classList.add('js-charms-added', 'charm-bigger-image');

                    this.charmsProductID.push(`${charmImagePosition}:${CharmVariantName}:${charmVariantId}:${charmVariantPrice}:${charmRotation}`);

                    let charmProp = charm.getAttribute('data-charm-prop');
                    let imageSrc = charm.getAttribute('src');
                    if (charmProp && imageSrc) {
                        let mainImageElement = this.mainImageGroup.querySelector(`[data-charm-prop="${charmProp}"]`);
                        if (mainImageElement) {
                            mainImageElement.src = imageSrc;
                            mainImageElement.classList.add('charm-bigger-image');
                        }
                    }
                }

                Array.from(this.charmPositions).slice(start, end).forEach(pos => {
                    if (!pos.classList.contains('js-is-empty')) {
                        pos.classList.remove('js-is-empty');
                        pos.classList.add('js-is-not-empty');
                    }
                });

                Array.from(this.charms).slice(start, end).forEach(char => {
                    if (!char.classList.contains('js-charms-added')) {
                        char.classList.add('js-charms-added');
                        char.style.cursor = 'pointer';
                    }
                });

                this.handleTotalPrice();
            }

            removeSelectedCharm(position) {
                let footSide = position.getAttribute('data-foot-side');
                let charmPosition = position.getAttribute('data-position');
                let allCharmPosition = Array.from(this.charms).filter(charm => charm.getAttribute('data-foot-side') === footSide);

                if(!this.insertPopup.classList.contains('hidden')) this.insertPopup.classList.add('hidden');

                let charm = this.querySelector(`.js-prod-charms[data-position="${charmPosition}"]`);
                allCharmPosition.forEach(container => {
                    if (container !== charm && !container.classList.contains('js-charms-added')) {
                        container.src = '';
                        container.style.opacity = '0.3';
                        container.style.cursor = 'default';
                        container.removeAttribute("data-charm-id");
                        container.removeAttribute("data-charm-price");
                        container.removeAttribute("data-charm-name");
                    }
                });

                let charmPositionReq = position.getAttribute('data-space-required');
                if(charmPositionReq == "4") {
                    this.removeBiggerCharm(position);
                    return;
                }
  
                charm.src = '';
                charm.removeAttribute('style');
                charm.style.opacity = 0.3;
                charm.style.cursor = 'default';
                charm.classList.remove('js-charms-added');
                position.classList.remove('js-is-not-empty');
                position.classList.add('js-is-empty');

                let charmImagePosition = charm.getAttribute("data-charm-prop");
                let CharmVariantName = charm.getAttribute("data-charm-name");
                let charmVariantId = charm.getAttribute("data-charm-id");
                let charmVariantPrice = charm.getAttribute("data-charm-price");
                let charmRotation = parseInt(charm.getAttribute("data-rotation")) || 0;
                
                this.charmsProductID = this.charmsProductID.filter(item => item !== `${charmImagePosition}:${CharmVariantName}:${charmVariantId}:${charmVariantPrice}:${charmRotation}`);

                charm.removeAttribute("data-charm-id");
                charm.removeAttribute("data-charm-price");
                charm.removeAttribute("data-charm-name");
                charm.removeAttribute('data-rotation');

                let charmProp = charm.getAttribute('data-charm-prop');
                if (charmProp) {
                    let mainImageElement = this.mainImageGroup.querySelector(`[data-charm-prop="${charmProp}"]`);
                    if (mainImageElement) {
                        mainImageElement.src = "";
                        mainImageElement.removeAttribute('style');
                        mainImageElement.removeAttribute('data-rotation');
                    }
                }

                if (charmPositionReq == "2") {
                    let pairMap = {
                        "1": "2",
                        "3": "2",
                        "5": "6",
                        "7": "6",
                        "8": "9",
                        "10": "9",
                        "12": "13",
                        "14": "13"
                    };

                    let placePosition = position.getAttribute('data-position-index');
                    let mappedIndex = pairMap[placePosition];

                    if (mappedIndex) {
                        let positionToClear = this.querySelector(`.js-charm-positions[data-position-index="${mappedIndex}"]`);
                        let charmToClear = this.querySelector(`.js-prod-charms[data-position-index="${mappedIndex}"]`);
                        if (positionToClear && charmToClear) {
                            positionToClear.classList.remove(`js-double-spaced-charm-${placePosition}`);
                            let hasCharmClass = Array.from(positionToClear.classList).some(cls => cls.startsWith('js-double-spaced-charm'));
                            if(!hasCharmClass) {
                                positionToClear.classList.remove('js-is-not-empty');
                                positionToClear.classList.add('js-is-empty');
                                charmToClear.classList.remove('js-charms-added');
                            }
                        }
                    }
                }

                if (charmPositionReq == "3") {
                    let tripleMap = {
                        "1": ["2", "3"],
                        "5": ["6", "7"],
                        "8": ["9", "10"],
                        "12": ["13", "14"]
                    };

                    let placePosition = position.getAttribute('data-position-index');
                    let mappedIndices = tripleMap[placePosition];

                    if (mappedIndices) {
                        mappedIndices.forEach(mappedIndex => {
                            let positionToClear = this.querySelector(`.js-charm-positions[data-position-index="${mappedIndex}"]`);
                            let charmToClear = this.querySelector(`.js-prod-charms[data-position-index="${mappedIndex}"]`);
                            if (positionToClear && charmToClear) {
                                positionToClear.classList.remove(`js-triple-spaced-charm-${placePosition}`);
                                let hasCharmClass = Array.from(positionToClear.classList).some(cls => cls.startsWith('js-triple-spaced-charm'));
                                if(!hasCharmClass) {
                                    positionToClear.classList.remove('js-is-not-empty');
                                    positionToClear.classList.add('js-is-empty');
                                    charmToClear.classList.remove('js-charms-added');
                                }
                            }
                        });
                    }
                }

                this.charmPositions.forEach((position) => {
                    if(!position.classList.contains('js-is-not-empty')) {
                        position.removeAttribute('data-space-required');
                        position.classList.add('js-is-empty');
                    }
                });

                this.handleTotalPrice();
            }

            removeBiggerCharm(position) {
                let isLeft = position.getAttribute('data-foot-side') === "left";
                let charmSelector = isLeft ? '[data-position="left-c1"]' : '[data-position="right-c5"]';
                let start = isLeft ? 0 : 10;
                let end = start + 4;

                let charm = this.querySelector(`.js-prod-charms${charmSelector}`);
                if (charm) {
                    let charmImagePosition = charm.getAttribute("data-charm-prop");
                    let CharmVariantName = charm.getAttribute("data-charm-name");
                    let charmVariantId = charm.getAttribute("data-charm-id");
                    let charmVariantPrice = charm.getAttribute("data-charm-price");
                    let charmRotation = 0;
                    this.charmsProductID = this.charmsProductID.filter(item => item !== `${charmImagePosition}:${CharmVariantName}:${charmVariantId}:${charmVariantPrice}:${charmRotation}`);

                    charm.src = ''; 
                    charm.style.opacity = '0.3';
                    charm.style.cursor = 'default';
                    charm.classList.remove('js-charms-added', 'charm-bigger-image');
                    charm.removeAttribute("data-charm-id");
                    charm.removeAttribute("data-charm-price");
                    charm.removeAttribute("data-charm-name");

                    let charmProp = charm.getAttribute('data-charm-prop');
                    if (charmProp) {
                        let mainImageElement = this.mainImageGroup.querySelector(`[data-charm-prop="${charmProp}"]`);
                        if (mainImageElement) {
                            mainImageElement.src = "";
                            mainImageElement.classList.remove('charm-bigger-image');
                        }
                    }
                }

                Array.from(this.charmPositions).slice(start, end).forEach(pos => {
                    if (pos.classList.contains('js-is-not-empty')) {
                        pos.classList.add('js-is-empty');
                        pos.classList.remove('js-is-not-empty');
                        pos.removeAttribute('data-space-required');
                    }
                });

                Array.from(this.charms).slice(start, end).forEach(char => {
                    if (char.classList.contains('js-charms-added')) {
                        char.classList.remove('js-charms-added');
                        char.style.cursor = 'default';
                        char.src = '';
                        charm.style.opacity = '0.3';
                    }
                });

                this.handleTotalPrice();
            }

            rotateSelectedCharm(position) {
                let charmPosition = position.getAttribute('data-position');
                let charm = this.querySelector(`.js-prod-charms[data-position="${charmPosition}"]`);
                let charmProp = charm?.getAttribute('data-charm-prop');
                let mainImageElement = this.mainImageGroup.querySelector(`[data-charm-prop="${charmProp}"]`);
                if (!charm) return;

                let currentRotation = parseInt(charm.dataset.rotation || "0");
                currentRotation += 30;

                charm.style.transform = `rotate(${currentRotation}deg)`;
                charm.style.transition = 'transform 0.3s ease';

                mainImageElement.style.transform = `rotate(${currentRotation}deg)`;
                mainImageElement.style.transition = 'transform 0.3s ease';

                charm.dataset.rotation = currentRotation;
                mainImageElement.dataset.rotation = currentRotation;
            }

            selectFootImage() {
                if(this.changeFootBtn) {
                    this.changeFootBtn.addEventListener('click', () => {
                        if(this.changeFootBtn.classList.contains('js-change-right-foot')) {
                            this.changeFootBtn.classList.remove('js-change-right-foot');
                            this.changeFootBtn.innerHTML = 'GO LEFT';
                            this.leftFootImage.classList.add('hidden');
                            this.rightFootImage.classList.remove('hidden');
                        }
                        else {
                            this.changeFootBtn.classList.add('js-change-right-foot');
                            this.changeFootBtn.innerHTML = 'GO RIGHT';
                            this.leftFootImage.classList.remove('hidden');
                            this.rightFootImage.classList.add('hidden');
                        }

                        this.charms.forEach((charm) => {
                            if(!charm.classList.contains('js-charms-added')) {
                                charm.src = "";
                                charm.style.opacity = '0.3';
                                charm.style.cursor = 'default';
                            }
                        });
                        this.charmPositions.forEach((position) => {
                            if(!position.classList.contains('js-is-not-empty')) {
                                position.classList.add('js-is-empty');
                            }
                        })
                    })
                }
            }

            selectRibbons() {
                let prodRibbons = this.querySelectorAll('.js-flip-flop-ribbon');
                let soleRibbons = this.querySelectorAll('.js-sole-ribbon');
                let ribbonNameWrapper = this.querySelector('.js-ribbon-head');
                let ribbonContainer = this.querySelector('.js-ribbon-grid-slider');

                if(prodRibbons.length > 0 && soleRibbons.length > 0) {
                    this.applyStockStateToSlides(prodRibbons);
                    prodRibbons.forEach((ribbon) => {
                        ribbon.addEventListener('click', () => {
                            if (this.isElementOutOfStock(ribbon)) return;
                            prodRibbons.forEach(r => r.classList.remove('active'));
                            ribbon.classList.add('active');

                            let ribbonName = ribbon.getAttribute('data-ribbon-variant-title');
                            let ribbonId = ribbon.getAttribute('data-ribbon-variant-id');
                            ribbonNameWrapper.innerHTML = ribbonName;

                            if(!ribbon.classList.contains('js-remove-ribbon')) {
                                let ribbonSrc = ribbon.querySelector('img')?.getAttribute('src');
                                if(ribbonSrc) {
                                    soleRibbons.forEach((soleRibbon) => {
                                        soleRibbon.src = ribbonSrc;
                                    })
                                }
                            }
                            else {
                                soleRibbons.forEach(soleRibbon => soleRibbon.src = '');
                            }

                            this.selectProductsID = this.selectProductsID.filter(item => !item.hasOwnProperty('ribbonColor'));
                            this.selectProductsID.push({ ribbonColor: ribbonId });
                            this.handleTotalPrice();
                        });
                        ribbon.addEventListener('mouseenter', () => {
                            if (this.isElementOutOfStock(ribbon)) return;
                            if(!ribbon.classList.contains('js-remove-ribbon')) {
                                this.charmImageZoom(ribbon);
                            }
                        });
                    })
                }

                if(ribbonContainer) {
                    ribbonContainer.addEventListener('mouseleave', () => {
                        this.querySelector('.js-charm-img-zoom')?.classList.add("hidden")
                    });
                }
            }

            handleTotalPrice() {
                let totalPriceWrapper = this.querySelectorAll('.js-total-price');

                let solePriceItem = this.selectProductsID.find(item => 'soleColorPrice' in item);
                let strapPriceItem = this.selectProductsID.find(item => 'strapColorPrice' in item);

                let activeRibbon = this.querySelector('.js-flip-flop-ribbon.active');
                let ribbonPrice = activeRibbon?.getAttribute('data-ribbon-variant-price');

                let total = 0;
                if (solePriceItem) total += solePriceItem.soleColorPrice;
                if (strapPriceItem) total += strapPriceItem.strapColorPrice;
                if (this.charmsProductID.length > 0) {
                    this.charmsProductID.forEach(entry => {
                        let parts = entry.split(':');
                        if (parts.length > 0) {
                            total += parseInt(parts[3]);
                        }
                    });
                }
                if (ribbonPrice) total += parseInt(ribbonPrice);
                
                setTimeout(() => {
                    this.querySelector('.js-from-text')?.classList.remove('hidden');
                    totalPriceWrapper.forEach(wrapper => {
                        wrapper.innerHTML = Shopify.formatMoney(total);
                    })
                }, 500);
            }

            handleAddToCartTab() {
                let size = this.querySelector('.js-cart-bundle-size');
                let cartSole = this.querySelector('.js-cart-sole-name');
                let cartSolePrice = this.querySelector('.js-cart-sole-price');
                let cartStrap = this.querySelector('.js-cart-strap-name');
                let cartStrapPrice = this.querySelector('.js-cart-strap-price');
                this.charmDetails = this.querySelector('.js-charm-details');
                let cartNoCharm = this.charmDetails.querySelector('.js-cart-no-charm');
                let charmList = this.charmDetails.querySelector('.js-cart-charms-list');
                let cartRibboName = this.querySelector('.js-class-ribbon-name');
                let cartRibbonPrice = this.querySelector('.js-cart-ribbon-price');
                let activeRibbon = this.querySelector('.js-flip-flop-ribbon.active');
                let ribbonPrice = activeRibbon?.getAttribute('data-ribbon-variant-price');
                let cartTotalPrice = this.querySelector('.js-total-cart-price');

                let sizeValue = this.flipFlopSize.value.split('-');
                size.innerHTML = sizeValue[0];

                cartSole.innerHTML = this.soleColorName.innerHTML;
                cartStrap.innerHTML = this.strapColorName.innerHTML;

                let solePriceItem = this.selectProductsID.find(item => 'soleColorPrice' in item);
                let strapPriceItem = this.selectProductsID.find(item => 'strapColorPrice' in item);
                
                cartSolePrice.innerHTML = solePriceItem ? Shopify.formatMoney(solePriceItem.soleColorPrice) : "0";
                cartStrapPrice.innerHTML = strapPriceItem ? Shopify.formatMoney(strapPriceItem.strapColorPrice) : "0";

                if(this.charmsProductID.length == 0) {
                    if (charmList) charmList.remove();
                    cartNoCharm.innerHTML = "No charm";
                }
                else {
                    let charmOrder = [
                        'left-c1', 'left-c2', 'left-c3', 'left-c4', 'left-c5', 'left-c6', 'left-c7',
                        'right-c1', 'right-c2', 'right-c3', 'right-c4', 'right-c5', 'right-c6', 'right-c7'
                    ];
                    let charmObjects = this.charmsProductID.map(entry => {
                        let [position, title, id, price] = entry.split(':');
                        return { position, title, id, price: parseInt(price) };
                    });

                    charmObjects.sort((a, b) => {
                        return charmOrder.indexOf(a.position) - charmOrder.indexOf(b.position);
                    });

                    if (charmList) charmList.remove();

                    let newList = document.createElement('ul');
                    newList.classList.add('js-cart-charms-list');

                    charmObjects.forEach(charm => {
                        let li = document.createElement('li');
                        let nameSpan = document.createElement('span');
                        nameSpan.classList.add('cart-charm-title');
                        nameSpan.textContent = charm.title;

                        let priceSpan = document.createElement('span');
                        priceSpan.classList.add('cart-charm-price');
                        priceSpan.innerHTML = Shopify.formatMoney(charm.price);

                        li.appendChild(nameSpan);
                        li.appendChild(priceSpan);
                        newList.appendChild(li);
                    });

                    this.charmDetails.appendChild(newList);
                }

                cartRibboName.innerHTML = activeRibbon?.getAttribute("data-ribbon-variant-title");
                cartRibbonPrice.innerHTML = Shopify.formatMoney(ribbonPrice);


                let total = 0;
                if (solePriceItem) total += solePriceItem.soleColorPrice;
                if (strapPriceItem) total += strapPriceItem.strapColorPrice;
                if (ribbonPrice) total += parseInt(ribbonPrice);
                if (this.charmsProductID.length > 0) {
                    this.charmsProductID.forEach(entry => {
                        let parts = entry.split(':');
                        if (parts.length > 0) {
                            total += parseInt(parts[3]);
                        }
                    });
                }

                cartTotalPrice.innerHTML = Shopify.formatMoney(total);
            }

            applyFilters() {
                let activeFilterButtons = this.querySelectorAll('.js-filter.active');
                let charmsDataScript = this.querySelector(".js-charms-data");

                if (!charmsDataScript) return;

                let charmsData = JSON.parse(charmsDataScript.textContent);

                let activeFilters = Array.from(activeFilterButtons).map(btn =>
                    btn.getAttribute('data-filter')
                );

                Object.entries(charmsData).forEach(([key, charmHTML]) => {
                    let tempWrapper = document.createElement('div');
                    tempWrapper.innerHTML = charmHTML;
                    let slide = tempWrapper.firstElementChild;
                    if (!slide) return;

                    let labels = slide.getAttribute('data-filter-labels') || "";
                    let labelList = labels.split(',').map(l => l.trim());

                    let matches = activeFilters.length === 0 || activeFilters.some(f => labelList.includes(f));

                    if (matches || key == "none--0") {
                        slide.classList.remove('hidden');
                    } else {
                        slide.classList.add('hidden');
                    }

                    charmsData[key] = tempWrapper.innerHTML;
                });

                charmsDataScript.textContent = JSON.stringify(charmsData);
                this.arrangeCharms();
            }

            getRibbonQuantityPerBundle() {
                return 2;
            }

            buildBundleConfiguration() {
                const normalizeUrl = (url) => {
                    if (!url) return '';
                    if (url.startsWith('//')) return `https:${url}`;
                    return url;
                };

                const config = {
                    size: '',
                    mainImage: '',
                    sole: { name: '', swatch_image: '', swatch_color: '' },
                    strap: { name: '', swatch_image: '', swatch_color: '' },
                    ribbon: null,
                    charms: []
                };

                const selectedSizeRaw = this.flipFlopSize?.value || '';
                const selectedSize = selectedSizeRaw.split('-')[0] || selectedSizeRaw;
                config.size = selectedSize;

                const lookupVariantData = (data, scriptKey, colorHandle) => {
                    if (!data) return null;
                    if (data[scriptKey]) return data[scriptKey];
                    if (!colorHandle) return null;
                    for (const key in data) {
                        if (key.includes(colorHandle)) return data[key];
                    }
                    return null;
                };

                const soleScript = this.querySelector('.js-sole-color-product');
                if (this.activeSole && soleScript) {
                    const soleData = JSON.parse(soleScript.textContent);
                    const colorHandle = this.activeSole.getAttribute('data-sole-color-name');
                    const scriptKey = `${selectedSize}-${colorHandle}`;
                    const variantData = lookupVariantData(soleData, scriptKey, colorHandle);
                    if (variantData) {
                        config.mainImage = normalizeUrl(variantData.mainImage || '');
                        config.sole = {
                            name: this.soleColorName?.innerHTML?.trim() || '',
                            swatch_image: normalizeUrl(variantData.swatch_image || ''),
                            swatch_color: variantData.swatch_color || ''
                        };
                    }
                }

                const strapScript = this.querySelector('.js-strap-color-product');
                if (this.activeStrap && strapScript) {
                    const strapData = JSON.parse(strapScript.textContent);
                    const sizeMapping = this.getStrapSizeMapping();
                    const strapSize = sizeMapping[selectedSize] || selectedSize;
                    const colorHandle = this.activeStrap.getAttribute('data-strap-color-name');
                    const scriptKey = `${strapSize}-${colorHandle}`;
                    const variantData = lookupVariantData(strapData, scriptKey, colorHandle);
                    if (variantData) {
                        config.strap = {
                            name: this.strapColorName?.innerHTML?.trim() || '',
                            swatch_image: normalizeUrl(variantData.swatch_image || ''),
                            swatch_color: variantData.swatch_color || ''
                        };
                    }
                }

                const ribbonScript = this.querySelector('.js-ribbon-cart-data');
                const activeRibbon = this.querySelector('.js-flip-flop-ribbon.active');
                if (activeRibbon && ribbonScript) {
                    const ribbonTitle = activeRibbon.getAttribute('data-ribbon-variant-title');
                    if (ribbonTitle && ribbonTitle !== 'No ribbon') {
                        const ribbonData = JSON.parse(ribbonScript.textContent);
                        let ribbonEntry = null;
                        for (const key in ribbonData) {
                            if (ribbonData[key].title === ribbonTitle) {
                                ribbonEntry = ribbonData[key];
                                break;
                            }
                        }
                        if (ribbonEntry) {
                            config.ribbon = {
                                title: ribbonEntry.title,
                                image: normalizeUrl(ribbonEntry.image || ''),
                                quantity: this.getRibbonQuantityPerBundle()
                            };
                        }
                    }
                }

                const charmScript = this.querySelector('.js-charm-cart-data');
                if (this.charmsProductID.length > 0 && charmScript) {
                    const charmData = JSON.parse(charmScript.textContent);
                    const charmCounts = {};
                    const charmOrder = [
                        'left-c1','left-c2','left-c3','left-c4','left-c5','left-c6','left-c7',
                        'right-c1','right-c2','right-c3','right-c4','right-c5','right-c6','right-c7'
                    ];

                    this.charmsProductID.forEach(charm => {
                        const [position, name, id] = charm.split(':');
                        if (!charmCounts[id]) {
                            charmCounts[id] = {
                                title: name,
                                image: normalizeUrl(charmData[id]?.image || ''),
                                quantity: 0,
                                firstPosition: position
                            };
                        }
                        charmCounts[id].quantity += 1;
                    });

                    config.charms = Object.values(charmCounts).sort(
                        (a, b) => charmOrder.indexOf(a.firstPosition) - charmOrder.indexOf(b.firstPosition)
                    );
                }

                return config;
            }

            buildBundleCartProperties(config) {
                const properties = {};

                if (config.size) properties._bundle_size = config.size;
                if (config.mainImage) properties._bundle_main_image = config.mainImage;

                if (config.sole?.name) properties._bundle_sole_name = config.sole.name;
                if (config.sole?.swatch_color) properties._bundle_sole_swatch_color = config.sole.swatch_color;
                if (config.sole?.swatch_image) properties._bundle_sole_swatch_image = config.sole.swatch_image;

                if (config.strap?.name) properties._bundle_strap_name = config.strap.name;
                if (config.strap?.swatch_color) properties._bundle_strap_swatch_color = config.strap.swatch_color;
                if (config.strap?.swatch_image) properties._bundle_strap_swatch_image = config.strap.swatch_image;

                if (config.ribbon?.title) {
                    properties._bundle_ribbon_title = config.ribbon.title;
                    properties._bundle_ribbon_image = config.ribbon.image || '';
                    properties._bundle_ribbon_quantity = String(config.ribbon.quantity || 2);
                }

                if (config.charms?.length > 0) {
                    properties._bundle_charms = config.charms.map((charm) => {
                        const qty = charm.quantity || 1;
                        const title = charm.title || '';
                        const image = charm.image || '';
                        return `${qty}:::${title}:::${image}`;
                    }).join('|||');
                }

                return properties;
            }

            handleBundleAddToCart() {
                let now = new Date();
                let currentTime = now.getTime();
                let bundleConfiguration = this.buildBundleConfiguration();
                const ribbonPerBundle = bundleConfiguration.ribbon?.quantity || this.getRibbonQuantityPerBundle();

                let get = key => this.selectProductsID.find(obj => key in obj)?.[key];

                let items = [];

                items.push({
                    id: get('soleColor'),
                    quantity: 1,
                    properties: {
                        _is_flop_flop_bundle_prod: 'true',
                        _main_bundle_id: currentTime,
                        ...this.buildBundleCartProperties(bundleConfiguration)
                    }
                });

                ['strapColor', 'ribbonColor'].forEach(key => {
                    let id = get(key);
                    if (id) {
                        let item = {
                            id: id,
                            quantity: key === 'ribbonColor' ? ribbonPerBundle : 1,
                            properties: { 
                                _is_flop_flop_bundle_prod: 'true',
                                [`_bundle_${key.toLowerCase()}_product`]: 'true',
                                _sub_product_bundle_id: currentTime
                            }
                        };
                        items.push(item);
                    }
                });

                if (this.charmsProductID.length > 0) {
                    this.charmsProductID.forEach(charm => {
                        let [position, name, id, price, rotation] = charm.split(':');
                        items.push({
                            id,
                            quantity: 1,
                            properties: {
                                _sub_product_bundle_id: currentTime,
                                _is_flop_flop_bundle_prod: 'true',
                                _bundle_charm_product: 'true',
                                _bundle_product_position: position,
                                _bundle_product_angle: `${rotation % 360} degree`
                            }
                        });
                    });
                }

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items })
                })
                .then(async (response) => {
                    if (response.ok) {
                        window.location.href = '/cart';
                    } else {
                        let err = await response.json();
                        console.error('Failed to add to cart:', response.status, err);
                    }
                })
                .catch(err => console.error('Cart error:', err));
            }

            resetBundleWarning() {
                let warningPopup = this.querySelector('.js-reset-warning-popup');
                this.bundleWrapper.classList.add('hidden');
                warningPopup.classList.remove('hidden');
            }

            resetBundle() {
                let tabs = this.querySelectorAll('.js-tabs-content');
                let tabsContent = this.querySelectorAll('.js-tabs-inner');

                tabs.forEach(t => t.classList.remove('active'));
                tabsContent.forEach(tc => tc.classList.remove('active'));
                tabs[0].classList.add('active');
                tabsContent[0].classList.add('active');

                this.flipFlopSize.value = '';
                let firstSoleColor = this.querySelector('.js-flip-flop-sole-color');
                let firstStrapColor = this.querySelector('.js-flip-flop-strap-color');

                this.handleSoleColors(firstSoleColor);
                this.handleStrapColors(firstStrapColor);

                let prodRibbons = this.querySelectorAll('.js-flip-flop-ribbon');
                let clearRibbon = this.querySelector('.js-remove-ribbon');
                let soleRibbons = this.querySelectorAll('.js-sole-ribbon');
                let ribbonNameWrapper = this.querySelector('.js-ribbon-head');

                let ribbonName = clearRibbon.getAttribute('data-ribbon-variant-title');
                let ribbonId = clearRibbon.getAttribute('data-ribbon-variant-id');
                ribbonNameWrapper.innerHTML = ribbonName;

                prodRibbons.forEach(r => r.classList.remove('active'));
                clearRibbon.classList.add('active');

                soleRibbons.forEach(soleRibbon => soleRibbon.src = '');
                this.selectProductsID = this.selectProductsID.filter(item => !item.hasOwnProperty('ribbonColor'));
                this.selectProductsID.push({ ribbonColor: ribbonId });

                this.clearCharms();
            }

            initializeSoleSlider(className, options) {
                if (this[`soleSlider_${options}`]) {
                    this[`soleSlider_${options}`].destroy(true, true);
                }
                this[`soleSlider_${options}`] = new SwiperV11(`.${className}`, {
                    slidesPerView: 6,
                    slidesPerGroup: 6,
                    spaceBetween: 0,
                    loop: false,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                    breakpoints: {
                        1024: {
                            slidesPerView: 6
                        },
                        768: {
                            slidesPerView: 6
                        },
                        480: {
                            slidesPerView: 6
                        }
                    }
                });
            }

            initializeMobileSoleSlider(className, options) {
                if (this[`soleMobileSlider_${options}`]) {
                    this[`soleMobileSlider_${options}`].destroy(true, true);
                }
                this[`soleMobileSlider_${options}`] = new SwiperV11(`.${className}`, {
                    slidesPerView: 6,
                    slidesPerGroup: 6,
                    loop: false,
                    breakpoints: {
                        320: {
                            slidesPerView: 4,
                            slidesPerGroup: 4,
                            grid: {
                                rows: 2,
                                fill: 'row'
                            },
                        },
                        500: {
                            slidesPerView: 6,
                            slidesPerGroup: 6,
                            grid: {
                                rows: 3,
                                fill: 'row'
                            },
                        },
                        751: {
                            slidesPerView: 6,
                        }
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                });
            }

            charmsSlider(className, options) {
                if (this[`gridSlider_${options}`]) {
                    this[`gridSlider_${options}`].destroy(true, true);
                }
                this[`gridSlider_${options}`] = new SwiperV11(`.${className}`, {
                    slidesPerView: 6,
                    slidesPerGroup: 6,
                    loop: false,
                    grid: {
                        rows: 3,
                        fill: 'row'
                    },
                    breakpoints: {
                        751: {
                            slidesPerView: 6,
                            slidesPerGroup: 6,
                            grid: {
                                rows: 3,
                                fill: 'row'
                            },
                        },
                        500: {
                            slidesPerView: 5,
                            slidesPerGroup: 5,
                            grid: {
                                rows: 3,
                                fill: 'row'
                            },
                        },
                        320: {
                            slidesPerView: 4,
                            slidesPerGroup: 4,
                            grid: {
                                rows: 2,
                                fill: 'row'
                            },
                        }
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                });
            }

        }
    );
}